export default "__VITE_ASSET__DbwfHGoN__"